/** @module csi/widget/_svg/fill */
define([
	"./_Color",
	"./PluginFactory"
], function(_Color, PluginFactory) {

	return PluginFactory.declare(_Color, {
		bHideWhenDisabled: true,
		"class": "csi-color-icon csi-text-formatting-select-button-no-border",
		propertyKey: "spPr.fill.color",
		materialIcon: "format_color_fill",
		pluginName: "fill",
		title: "CanvasFillColor",

		/**
		 * Enable plugin if selected shapes support fill, or no selected shapes and in appropriate drawing mode
		 */
		enablePlugin: function(shapes, shapeAttrs, textAttrs) {
			return this.inherited(arguments) && this.editor.canvasApp.selection.isSelectedShapesSupportFill();
		}
	});
});
